export const shallowDedup = (arr: string[] = []) =>
  arr.filter((val, idx, self) => idx === self.indexOf(val));
